<template>
  <header class="app-header">
    <div class="header-content">
      <div class="header-left">
        <img 
          src="@/assets/logo-v2.png" 
          alt="DietEdics" 
          class="app-logo" 
          @click="goHome"
        />
      </div>
      <div class="header-right">
        <nav class="header-nav">
          <button v-if="showSearchCoursesButton" @click="goToSearch" class="nav-link">Search Courses</button>
          <button v-if="isAdmin" @click="goToAdmin" class="nav-link">Admin</button>
          <button v-if="isAuthenticated" @click="goToProfile" class="nav-link">My Profile</button>
          <button v-if="isAuthenticated" @click="handleLogout" class="nav-link logout-button">Sign Out</button>
          <template v-if="!isAuthenticated">
            <button @click="goToSignUp" class="nav-link">Sign Up</button>
            <button @click="showLogin" class="nav-link">Sign In</button>
          </template>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import { logout } from '../../services/authService.js'

export default {
  name: 'AppHeader',
  props: {
    currentUser: {
      type: Object,
      default: null
    }
  },
  computed: {
    isAuthenticated() {
      // The currentUser prop is the source of truth for authentication state
      // If currentUser is null, user is not authenticated
      return this.currentUser !== null
    },
    isAdmin() {
      // Check if current user is an admin
      return this.currentUser?.isAdmin === true
    },
    showSearchCoursesButton() {
      const name = this.$route?.name
      return name !== 'landing' && name !== 'search'
    }
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'landing' })
    },
    goToSearch() {
      this.$router.push({ name: 'search' })
    },
    goToAdmin() {
      this.$router.push({ name: 'admin' })
    },
    showLogin() {
      this.$emit('show-login')
    },
    goToSignUp() {
      this.$router.push({ name: 'signup' })
    },
    goToProfile() {
      this.$router.push({ name: 'profile' })
    },
    async handleLogout() {
      await logout()
      this.$emit('user-changed')
      // Navigate to landing page after logout
      this.$router.push({ name: 'landing' })
    }
  }
}
</script>

<style scoped>
.app-header {
  background-color: var(--color-surface-light);
  border-bottom: 2px solid var(--color-border-light);
  padding: 15px 20px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.header-left {
  display: flex;
  align-items: center;
}

.app-logo {
  height: 7rem;
  width: auto;
  cursor: pointer;
  transition: opacity var(--transition-normal);
}

.app-logo:hover {
  opacity: 0.8;
}

.header-right {
  display: flex;
  align-items: center;
}

.header-nav {
  display: flex;
  gap: 12px;
  align-items: center;
}

.nav-link {
  background: var(--color-surface-elevated);
  border: none;
  border-left: 2px solid var(--color-border-main);
  border-bottom: 2px solid var(--color-border-main);
  color: var(--color-text-primary);
  font-size: 1.125rem;
  font-family: inherit;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all var(--transition-normal);
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
  display: inline-block;
}

.nav-link:hover {
  background-color: var(--color-primary-main);
  color: var(--color-text-inverse);
  border: 2px solid var(--color-primary-main);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

/* Inverse colors for Sign Out button */
.nav-link.logout-button {
  background-color: var(--color-primary-main);
  color: var(--color-text-inverse);
  border: 2px solid var(--color-primary-main);
}

.nav-link.logout-button:hover {
  background: var(--color-surface-elevated);
  color: var(--color-text-primary);
  border-left: 2px solid var(--color-border-main);
  border-bottom: 2px solid var(--color-border-main);
}

@media (max-width: 768px) {
  .header-content {
    flex-wrap: wrap;
  }

  .header-right {
    width: 100%;
    justify-content: space-between;
  }

  .header-nav {
    gap: 10px;
  }

  .nav-link {
    font-size: 0.9rem;
    padding: 6px 10px;
  }
}
</style>

